// extracted by mini-css-extract-plugin
export default {"container":"Map_container__a3xlX","playerPos":"Map_playerPos__iNKjI"};